export default "__VITE_ASSET__zXJDf_5o__"